import { TextField } from '@fluentui/react';
import { currencySymbols, defaultCurrency } from './currencies';
import * as React from 'react';
export var CurrencyInput = function (_a) {
    var amount = _a.amount, _b = _a.currency, currency = _b === void 0 ? defaultCurrency : _b, onChange = _a.onChange, name = _a.name, placeholder = _a.placeholder, _c = _a.label, label = _c === void 0 ? 'Amount' : _c;
    return (React.createElement(TextField, { label: label, value: amount || amount === 0 ? amount.toString() : '', prefix: currencySymbols[currency.toLowerCase()], type: "number", placeholder: placeholder, name: name, onChange: onChange }));
};
